import type { JSX } from 'react'

import { Input } from '../design-system/input.tsx'
import { readSlackChannel } from '../lib/alert-slack-channel.ts'

/**
 * The Slack channel an alert posts to, as one text field.
 *
 * A blank field shows no error until the reader types, so the field does not
 * open red. The step's Next button still waits for a channel.
 *
 * @param props - Field props.
 * @param props.value - What the field holds.
 * @param props.onChange - Sets what the field holds.
 * @param props.data-testid - The field's test id.
 * @returns The field.
 */
export function SlackChannelField({
  value,
  onChange,
  'data-testid': testId
}: {
  value: string
  onChange: (value: string) => void
  'data-testid': string
}): JSX.Element {
  const read = readSlackChannel(value)

  return (
    <Input
      data-testid={testId}
      label="Slack channel"
      value={value}
      onChange={event => onChange(event.target.value)}
      error={read.ok || value.trim() === '' ? undefined : read.problem}
      hint="Paste the channel’s link, from Copy link. Add the BlytzPay Alerts app to the channel first. Channels shared with another company are refused."
    />
  )
}
